const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20wide%20panoramic%20composition%20with%20warm%20amber%20and%20deep%20charcoal%20gradients%2C%20elegant%20cinematic%20widescreen%20aesthetic%2C%20modern%20digital%20art%20style%20with%20flowing%20organic%20shapes%2C%20premium%20entertainment%20platform%20visual%2C%20rich%20golden%20accents%20on%20dark%20background%2C%20sophisticated%20atmosphere&width=1200&height=600&seq=carousel-rv-01&orientation=landscape',
    tag: '蜜桃视频',
    title: '蜜桃视频独家推荐 · 本月精选合集上线',
    desc: '本月蜜桃视频最受关注的独家内容已全部更新，涵盖多类型热门专题，VIP会员免费观看全部精选。',
    meta: '42 部精选 · 更新于 2 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20wide%20panoramic%20composition%20with%20rich%20burgundy%20and%20dark%20obsidian%20color%20palette%2C%20elegant%20cinematic%20widescreen%20aesthetic%2C%20modern%20art%20style%20with%20smooth%20gradients%2C%20premium%20curated%20content%20visual%2C%20warm%20crimson%20accents%20on%20deep%20background&width=1200&height=600&seq=carousel-rv-02&orientation=landscape',
    tag: '红桃视频',
    title: '红桃视频编辑力荐 · 高分作品专题发布',
    desc: '红桃视频编辑团队本季精心筛选的高分作品合集，品质保证，不容错过的精品推荐。',
    meta: '28 部精选 · 更新于 5 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20wide%20panoramic%20composition%20with%20golden%20bronze%20and%20charcoal%20gradients%2C%20elegant%20cinematic%20widescreen%20style%2C%20modern%20digital%20art%20with%20dynamic%20curves%2C%20premium%20streaming%20platform%20visual%2C%20warm%20metallic%20highlights%20on%20dark%20canvas&width=1200&height=600&seq=carousel-rv-03&orientation=landscape',
    tag: '香蕉视频',
    title: '香蕉视频VIP免费频道 · 156部精选全开放',
    desc: '原香蕉视频VIP会员专属内容全面免费开放，海量精选视频无需登录即可直接观看。',
    meta: '156 部精选 · 更新于 8 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20wide%20panoramic%20composition%20with%20copper%20rose%20and%20deep%20slate%20gradients%2C%20elegant%20cinematic%20widescreen%20aesthetic%2C%20modern%20art%20with%20flowing%20shapes%2C%20premium%20content%20curation%20visual%2C%20warm%20delicate%20highlights%20on%20dark%20background&width=1200&height=600&seq=carousel-rv-04&orientation=landscape',
    tag: '樱花视频',
    title: '樱花视频新番速递 · 本季热门作品全集',
    desc: '樱花视频频道最新番剧与热门内容一站式速递，同步上线最新最热的新番资源合集。',
    meta: '87 部精选 · 更新于 12 小时前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20wide%20panoramic%20composition%20with%20warm%20terracotta%20and%20dark%20charcoal%20gradients%2C%20elegant%20cinematic%20widescreen%20style%2C%20modern%20digital%20art%20with%20geometric%20patterns%2C%20trending%20entertainment%20visual%2C%20rich%20earthy%20accents%20on%20deep%20background&width=1200&height=600&seq=carousel-rv-05&orientation=landscape',
    tag: '排行榜',
    title: '全站热播排行榜 · 本周 TOP 50 更新',
    desc: '基于全站热度与用户评分综合计算的排行榜本周已更新，快速发现全网最受关注的好视频。',
    meta: '50 部上榜 · 更新于 1 天前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20wide%20panoramic%20composition%20with%20deep%20mahogany%20and%20dark%20obsidian%20gradients%2C%20elegant%20cinematic%20widescreen%20aesthetic%2C%20modern%20art%20style%20with%20dramatic%20lighting%2C%20premium%20curated%20series%20visual%2C%20rich%20warm%20highlights%20on%20deep%20canvas&width=1200&height=600&seq=carousel-rv-06&orientation=landscape',
    tag: '独家策划',
    title: '日皮视频独家策划 · 深度专题系列第三期',
    desc: '日皮视频团队原创深度专题系列，围绕经典主题整合多频道优质内容，沉浸式观影体验。',
    meta: '36 部精选 · 更新于 2 天前',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-[480px] mx-auto">
            蜜桃视频、红桃视频、香蕉视频、樱花视频等品牌频道的焦点专题内容一览
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-500/20 transition-all duration-300"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-background-50/20 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="inline-flex items-center px-2.5 py-1 text-xs font-medium rounded-full bg-primary-500/85 text-background-950 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-50 mb-1 font-heading line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-400 line-clamp-2 mb-2">
                    {item.desc}
                  </p>
                  <span className="text-xs text-foreground-500">{item.meta}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}